import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store'
import { Provider } from 'react-redux'
import { AuthProvider } from "./auth/AuthProvider.tsx";
const root = ReactDOM.createRoot(document.getElementById('root'));
// store.subscribe(() => {
//   const id = (window ).__storeId
//   const v = store.getState().param.value // or the simplified path
//   console.log(`[store ${id}] param now:`, v)
// })
root.render(
<AuthProvider>
  <Provider store={store}>
    <App />
  </Provider>
  </AuthProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
